// extracted by mini-css-extract-plugin
module.exports = {"frame":"compound-interest-table_frame__XDgAK"};